import React from "react";
import { getColumn } from "./column";
import CustomPagination from "../Common/CustomPagination";
import Table from "../Common/Table";
import { Col } from "react-bootstrap";

const TransactionTable = ({
  setBody,
  body,
  data,
  reFetch,
  loader,
  totalCount,
}) => {
  const col = getColumn(body);

  const pageChangeHandler = (page) => {
    const newBody = {
      ...body,
      page,
    };
    setBody(newBody);
    reFetch(newBody);
  };

  return (
    <Col lg="12" className="my-2">
      <div className="table-responsive">
        <Table data={data} loader={loader} column={col} />
        <div className="d-flex align-items-center justify-content-end mt-2">
          <div className="right">
            <CustomPagination
              current={body.page}
              pageChangeHandler={pageChangeHandler}
              pageSize={body.limit}
              total={totalCount}
            />
          </div>
        </div>
      </div>
    </Col>
  );
};

export default TransactionTable;
